module.exports = __webpack_public_path__ + "img/airport_transfer-1.309fad55.jpeg";